export const jpRegisterCommunityFinished = {
  SA27title: 'コミュニティ参加申請完了',
  SA27descriptionFirst: 'コミュニティへの参加申請を受け付けました。',
  SA27descriptionSecond: 'コミュニティ参加登録完了の連絡をお待ちください。',
}
